<template>
  <amplify-authenticator  :federated="federated">
    <amplify-sign-in
      header-text="trustMinder Uploader"
      slot="sign-in"
      hide-sign-up=true
      :federated.prop="{}"
    ></amplify-sign-in>
     <div v-if="authState === 'signedin' && user">
       <!-- <multiselect 
        style="display:none"
        v-model="selectedcampaign" 
        :options="campaigns"
        track-by="campaignID"
        label="name"
        placeholder="Select a campaign"
        :searchable="true"
        :allow-empty="true"
      ></multiselect> -->
      <amplify-greetings 
        :username="user.username"
        greetings-message="suckit"
       
        >
         <img slot="logo" src="https://login.trust-minder.com/ALL/20210625154057/assets/images/image.jpg" width="210" />
      </amplify-greetings>
      <div class="alert alert-info" role="alert">
        <ul style="list-style: none;">
          <li v-if="stage == 1">Drop a file in the area below</li>
          <li v-if="stage == 2">Now confirm what you want us to do with this file {{filename}}</li>
          <li v-if="stage == 3">
            That's been done.
            <button class="btn" @click="startagain">Click here to upload a new file</button>
          </li>
        </ul>
      </div>
      <dropfile v-if="stage == 1"  v-on:file="filedrop" ></dropfile>
      <div v-if="error" class="alert alert-error" role="alert">
        {{error}}
      </div>
       <button v-if="successfilekey &&  stage == 2" class=" btn-success btn" role="button" @click="addcontacts">
        Click here to add the file contents to the Contact Manager
      </button>
       <div v-if="stage == 4" class="alert alert-error" role="alert">
        We got your file but dont know what to do with it.
        We were expecting a .csv file.
        <br>
        <a :href="signedURL">{{filename}}</a>
      </div>
    </div>
      <!-- <amplify-sign-out></amplify-sign-out> -->
  </amplify-authenticator>
</template>

<script>
// https://github.com/aws-amplify/amplify-ui/tree/legacy/legacy/amplify-ui-vue
import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import { Storage, API } from 'aws-amplify';
import dropfile from './components/dropfile'
Storage.configure({ level: 'private' });
// import Multiselect from 'vue-multiselect'

export default {
  name: 'App',
  components: {
    dropfile
  },
  data() {
    return {
      stage:1,
      filename : undefined,
      contentType : undefined,
      error:false,
      successfilekey:false,
      user: undefined,
      authState: undefined,
      unsubscribeAuth: undefined,
      selectedcampaign:undefined,
      campaigns:[],
      federated:{}
    };
  },
 
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if(authData)
        console.info('get user campaigns')
        // this.getcampaigns()
    });
  },
  
  beforeUnmount() {
    this.unsubscribeAuth();
  },
  methods:{
    startagain (){
      this.stage = 1
      this.filename = undefined
      this.contentType = undefined
      this.error=false
      this.successfilekey=undefined
    },
    async addcontacts (){
      const myInit = {
        headers: {}, // OPTIONAL
        body: {
          files: [
            {
              campaignID: null,
              Bucket: 's3fileuploadbd332c9ecf84458b9a759a3017bc8ee385516-prod',
              Key: decodeURIComponent(this.successfilekey)
            }
          ],
          alice: { userID: this.user.username, title: this.filename },
          filecount: 1,
          file_idx: 0,
          source: 'S3',
          step: true,
          preprocessor: 'contacts',
          pgp: false,
          unzip: false,
          campaignID: false,
          wait: false,
          username: this.user.username,
          email: null,
          filesplitter: false,
          errorto: 'monit@cauwill.com',
          filetype: 'csv'
        }
      }
      try {
        let callstep = await API.post('campaignsapi', `/trigger`, myInit )
        this.stage = 3
        console.info(callstep)  
      } catch (error) {
        this.error = error
      }
      
    },
    async getcampaigns(){
      // const campaigns = await API.get('campaignsapi', `/campaigns`);
      // const usercampaignsapi = await API.get('campaignsapi', `/usercampaignsapi/${this.user.username}`);
      this.campaigns = await API.get('campaignsapi', `/campaigns/${this.user.username}`)
      // , {
      //   'queryStringParameters': {
      //     'order': 'byPrice'
      //   }
      // });
      // console.info(usercampaignsapi)
      // this.axios.get(`https://e5k3e6i36c.execute-api.eu-west-1.amazonaws.com/prod/campaigns/${this.user.username}`).then((response) => {
      //   console.log(response.data)
      // })
    },
    async filedrop (params){
      let self = this
      try {
        this.filename = params.file.name
        this.contentType = params.type
        
        let path = this.selectedcampaign ? `${this.user.username}/${this.selectedcampaign}/${params.file.name}` : `${this.user.username}/${params.file.name}`
        let storageresult = await Storage.put( path, params.file, {
           level: "private",
          contentType: params.type, // contentType is optional
          resumable: true,      
          completeCallback: (event) => {
            console.log(`Successfully uploaded ${event.key}`);
            
          },
          progressCallback: (progress) => {
              console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
          },
          errorCallback: (error) => {
              console.error('Unexpected error while uploading', error);
              self.error = error

          }
        });
        // console.info(storageresult)
        const signedURL = await Storage.get(storageresult.params.Key, {level:'private'} ); 
        let bucketuri = "https://s3fileuploadbd332c9ecf84458b9a759a3017bc8ee385516-prod.s3.eu-west-1.amazonaws.com/"
        this.successfilekey = signedURL.substring(bucketuri.length, (signedURL.indexOf(this.filename) + this.filename.length))
        if(['text/csv'].includes(params.type.toLowerCase()) || this.filename.split('.').pop().toLowerCase() == 'csv' ){
          this.stage = 2
        }else{
          this.signedURL = signedURL
          this.stage = 4
          if(params.type.toLowerCase() == 'application/vnd.ms-excel' || this.filename.split('.').pop().toLowerCase() == 'xlsx' ){
            this.error = "This looks like an excel file. We require a csv file if you want us to process it. You can export csv from excel and try again."
          }
        }
        
        console.info(signedURL)
      } catch (error) {
        this.error = `There has been a problem uploading your file: ${error}`
        console.log("Error uploading file: ", error);
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#app {

}
/* #password-hint{
  display: none;
} */
.multiselect__option--highlight {
    background: #d94c33 !important;
}
amplify-authenticator {
    --background-color: #d94c33;
}
amplify-greetings{
  --border-color: #fff;
}
:root{
  --amplify-primary-color:#d94c33;
}
.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}
.alert-error {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}
.btn-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}
.btn {
    cursor: pointer;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
/* slot[name="federated-buttons"]{
  display: none;
} */
</style>
